import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private platformId = inject(PLATFORM_ID);

  constructor(private snackBar: MatSnackBar) {}

  success(message: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.snackBar.open(message, 'Закрыть', {
      duration: 3000,
      panelClass: ['toast-success'],
      horizontalPosition: 'right',
      verticalPosition: 'top'
    });
  }

  error(message: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.snackBar.open(message, 'Закрыть', {
      duration: 4000,
      panelClass: ['toast-error'],
      horizontalPosition: 'right',
      verticalPosition: 'top'
    });
  }
}
